function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Head from "next/head";
import { PureComponent } from "react";
import Topbar from "/components/core/top-bar-new/top-bar-component";
import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";
import BaseTemplate from "/components/templates/base-template";
import OnePagerWithVideoComponent from "./one-pager-with-video-content/one-pager-with-video-content-component";
class OnePagerWithVideoTemplate extends PureComponent {
    onExitIntentCallback() {
        this.setState({
            forceClosePopup: true
        });
    }
    onCloseExitPopupCallback() {
        this.setState({
            forceClosePopup: false
        });
    }
    render() {
        let { headerUrl, exitPopup, loginTheme, menuTheme, stickyMode, pageConfig } = this.props;
        const { headerStrip, parts, footerSignup, nameSignature, socialButtons, topBanner, exitPopupConfig } = pageConfig;
        return /*#__PURE__*/ _jsxs(BaseTemplate, _object_spread_props(_object_spread({}, this.props, pageConfig), {
            children: [
                /*#__PURE__*/ _jsx(Topbar, {
                    url: headerUrl,
                    loginTheme: loginTheme,
                    menuTheme: menuTheme,
                    showMenu: false,
                    stickyMode: stickyMode,
                    allowSocialButtons: socialButtons && socialButtons.show,
                    socialButtonsColor: socialButtons && socialButtons.color,
                    mobileLogoTheme: "dark-theme",
                    topBanner: topBanner,
                    maxWidth: "100%",
                    headerBackgroundColor: "transparent"
                }),
                /*#__PURE__*/ _jsx("main", {
                    children: /*#__PURE__*/ _jsx(OnePagerWithVideoComponent, _object_spread_props(_object_spread({}, pageConfig), {
                        forceClosePopup: this.state.forceClosePopup
                    }))
                }),
                /*#__PURE__*/ _jsx(CoreAddonsComponent, {
                    exitPopup: exitPopup,
                    exitPopupConfig: exitPopupConfig
                })
            ]
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            forceClosePopup: false
        };
        this.onExitIntentCallback = this.onExitIntentCallback.bind(this);
        this.onCloseExitPopupCallback = this.onCloseExitPopupCallback.bind(this);
    }
}
export { OnePagerWithVideoTemplate as default };
OnePagerWithVideoTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};
